import {
  home,
  notifications,
  megaphone,
  stopwatch,
  personCircle,
} from "ionicons/icons";
import {
  Home,
  Notification,
  Announcement,
  Tes,
  Profile,
  DetailTes,
  ProfilSekolah,
  PerformTes,
} from "pages";
import { Login, OnBoard, ResetPassword } from "pages";

export const sideMenu = [
  {
    id: 1,
    icon: home,
    title: "Beranda",
    url: "/home",
  },
  {
    id: 2,
    icon: stopwatch,
    title: "Tes",
    url: "/tes",
  },
  {
    id: 3,
    icon: megaphone,
    title: "Pengumuman",
    url: "/announcement",
  },
  {
    id: 4,
    icon: notifications,
    title: "Notifikasi",
    url: "/notification",
  },
  {
    id: 5,
    icon: personCircle,
    title: "Profil",
    url: "/profile",
  },
];

export const tabMenu = [
  {
    id: 1,
    icon: home,
    title: "Beranda",
    url: "/home",
  },
  {
    id: 4,
    icon: megaphone,
    title: "Pengumuman",
    url: "/announcement",
  },
  {
    id: 3,
    icon: stopwatch,
    title: "Tes",
    url: "/tes",
  },
  {
    id: 2,
    icon: notifications,
    title: "Notifikasi",
    url: "/notification",
  },
  {
    id: 5,
    icon: personCircle,
    title: "Profil",
    url: "/profile",
  },
];

export const mainRoute = [
  {
    url: "/home",
    component: <Home />,
    exact: true,
  },
  {
    url: "/announcement",
    component: <Announcement />,
    exact: false,
  },
  {
    url: "/tes",
    component: <Tes />,
    exact: true,
  },
  {
    url: "/tes/:id",
    component: <DetailTes />,
    exact: true,
  },
  {
    url: "/performtes",
    component: <PerformTes />,
    exact: true,
  },
  {
    url: "/notification",
    component: <Notification />,
    exact: true,
  },
  {
    url: "/profile",
    component: <Profile />,
    exact: false,
  },
  {
    url: "/sekolah/:nama",
    component: <ProfilSekolah />,
    exact: true,
  },
];

export const authRoute = [
  {
    url: "/login",
    component: <Login />,
    exact: true,
  },
  {
    url: "/lupa-password",
    component: <ResetPassword />,
    exact: true,
  },
  {
    url: "/reset-password/:token",
    component: <ResetPassword />,
    exact: true,
  },
  {
    url: "/onboard",
    component: <OnBoard />,
    exact: true,
  },
];
